export const trimRefId = (string, characterLimit = 6) => {
	if (string.length > characterLimit) {
		const limitedString = string.slice(-characterLimit).trim()
		return '...' + limitedString
	}

	return string
}
